"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _textField = _interopRequireDefault(require("./textField"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    button: {
      fontWeight: 'bold'
    }
  };
});

var _default = function _default(_ref) {
  var handleLogin = _ref.handleLogin,
      toggle = _ref.toggle;
  var classes = useStyles();

  var _React$useState = _react["default"].useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      email = _React$useState2[0],
      setEmail = _React$useState2[1];

  var _React$useState3 = _react["default"].useState(''),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      password = _React$useState4[0],
      setPassword = _React$useState4[1];

  var handleEmailChange = function handleEmailChange(event) {
    var email = event.target.value;
    setEmail(email);
  };

  var handlePasswordChange = function handlePasswordChange(event) {
    var password = event.target.value;
    setPassword(password);
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (e.keyCode === 13) {
      e.preventDefault();
      handleLogin(email, password);
      return false;
    }
  };

  return _react["default"].createElement("div", null, _react["default"].createElement(_textField["default"], {
    autoFocus: true,
    fullWidth: true,
    label: "Correo electr\xF3nico",
    name: "email",
    onChange: handleEmailChange,
    placeholder: "tu@correo.com",
    value: email
  }), _react["default"].createElement(_textField["default"], {
    fullWidth: true,
    label: "Contrase\xF1a",
    name: "password",
    onChange: handlePasswordChange,
    placeholder: "Tu contrase\xF1a",
    type: "password",
    onKeyDown: handleKeyDown,
    value: password
  }), _react["default"].createElement("div", null, _react["default"].createElement("br", null), _react["default"].createElement(_Button["default"], {
    className: classes.button,
    color: "secondary",
    fullWidth: true,
    onClick: function onClick() {
      return handleLogin(email, password);
    },
    variant: "contained"
  }, "Iniciar sesi\xF3n"), _react["default"].createElement("br", null), _react["default"].createElement("br", null), _react["default"].createElement(_Button["default"], {
    className: classes.button,
    color: "secondary",
    fullWidth: true,
    onClick: toggle
  }, "Olvid\xE9 mi contrase\xF1a")));
};

exports["default"] = _default;